import React, { useState } from "react";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import { checkuserexits } from "../utilities/userauth";
import { useNavigate } from "react-router-dom";

const ResetPassword = ({ isLogin }) => {
  const navigate = useNavigate();
  const [email, resetemail] = useState("");

  const handleOnChange = (e) => {
    const { value } = e.target;
    resetemail(value);
  };

  const Submithandler = async (e) => {
    e.preventDefault();
    alert(email);
    const res = await checkuserexits(email);
    if (res.data.message === "success") {
      console.log("resery page ---", res);
      navigate("/ResetPage");
    } else {
      alert("No email existed with this email");
    }
  };

  return (
    <Container>
      <Row>
        <Col>
          <h3>Reset Password Page</h3>
          <hr />
          <Form onSubmit={Submithandler}>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={email}
                placeholder="email"
                onChange={handleOnChange}
              />
              <Button type="submit" className="mt-2">
                Submit
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Row>
      <Row>
        <a href="#!" onClick={() => isLogin("login")}>
          Login!
        </a>
      </Row>
    </Container>
  );
};

export default ResetPassword;
